// generated from 1_866 samples

import { z } from "zod";
import { common } from "../common";

export const interactedWithCampaignPushOnlyTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::InteractedWithCampaignpush_only"),
  interaction: z.enum([
    "op", // 1_834 (98.29%)
    "tc", // 27 (1.45%)
    "t1", // 4 (0.21%)
    "t0", // 1 (0.05%)
  ]),
  // null: 461 (24.71%)
  selected_campaign_id: common.objectId.nullable(),
  // null: 461 (24.71%)
  selected_campaign_name: z.string().nullable(),
  selected_carousel_slide_id: z.string().nullable(),
  selected_carousel_slide_name: z.string().nullable(),
  selected_push_button_name: z.string().nullable(),
  selected_push_button_string: z.string().nullable(),
});
